import useWidth from '@components/Hooks/useWidth';
import useOnNavigate from '../../../hooks/useOnNavigate';
import { useRachelStore } from '../store/rachel.store';
import { selectCloseRachel } from '../store/rachel.store.selectors';

export const useCloseRachelOnNavigate = () => {
  const { isCustomizedTabletDown } = useWidth();
  const close = useRachelStore(selectCloseRachel);

  useOnNavigate(() => {
    if (isCustomizedTabletDown) {
      close();
    }
  });
};
